import { mountVueComponent } from '@/lib/mount-vue-component';

export default function () {
	import('@/modules/webhooks/WebhookForm.vue').then((webhookForm) => {
		mountVueComponent('webhook-form', webhookForm);
	});
}
